"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartiesListContainer = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var memoize = require("fast-memoize");
var ColumnFilter_1 = require("components/ColumnFilter");
var sok_ui_1 = require("@caddigital/sok-ui");
var UsersActions = require("@caddigital/sok-reducers/lib/actions/project/users");
var ProjectHomeAtions = require("@caddigital/sok-reducers/lib/actions/project/home");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var Types = require("types");
var viewport_1 = require("reducers/viewport");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
var avatars_1 = require("components/Avatar/avatars");
var SearchBar_1 = require("components/SearchBar");
var PartiesTabConfirmModal_1 = require("./PartiesTabConfirmModal");
var SortButton = sok_ui_1.Table.SortButton;
var headers = [
    'avatar',
    'name',
    'company',
    'address',
    'telephone',
    'email',
    'title'
];
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    var projectId = -1;
    var projectShowPartiesTab = false;
    var projectAdmins;
    var showToggleShowPartiesTab = false;
    if (state.project.currentProject.status === 'FETCHED' &&
        state.project.currentProject.project.perm) {
        projectId = state.project.currentProject.project.id;
        projectShowPartiesTab = state.project.currentProject.project.showPartiesTab;
        projectAdmins = state.project.currentProject.project.projectAdmins;
        showToggleShowPartiesTab = state.auth.current.user.fold(false, function (user) {
            return user.level === 'SuperAdminUserGroup' ||
                (!!projectAdmins && projectAdmins.includes(user.email));
        });
    }
    return {
        projectId: projectId,
        projectShowPartiesTab: projectShowPartiesTab,
        showToggleShowPartiesTab: showToggleShowPartiesTab,
        status: state.project.users.status,
        users: state.project.users.userList,
        filterOptions: state.project.users.filterOptions,
        limit: state.project.users.sortingAndPagination.limit,
        offset: state.project.users.sortingAndPagination.offset,
        sortingAndPagination: state.project.users.sortingAndPagination,
        list: state.distribution.list,
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        selectedLanguage: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    onPaginationChange: function (offset, limit) { return (dispatch(UsersActions.setLimit(limit)),
        dispatch(UsersActions.setOffset(offset))); },
    setOffset: function (offset) { return dispatch(UsersActions.setOffset(offset)); },
    sortBy: function (sortBy, order) {
        return dispatch(UsersActions.setOrderByOptions(sortBy, order));
    },
    setColumnFilter: function (filter, value) {
        return dispatch(UsersActions.setFilterOptions(filter, value));
    },
    toggleShowParties: function (projectId, showParties) {
        return dispatch(ProjectHomeAtions.toggleShowPartiesRequest(projectId, showParties));
    },
    getUserListExcel: function (projectId) {
        return dispatch(UsersActions.fetchProjectUserListExcelRequest(projectId));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var getColumns = function (items, isMobile) {
    var columns = items.reduce(function (p, item) {
        Object.keys(item).forEach(function (c) {
            if (isMobile) {
                if (c !== 'name') {
                    return;
                }
            }
            if (c === 'avatar') {
                return;
            }
            var dataKey = '__users-list__' + c.replace(/-/g, '');
            var text = (function (v, c) {
                return (v || '').toString();
            })(item[c], c);
            var length = (0, text_1.calculateStringLength)(text);
            var prevValue = p[dataKey];
            if (prevValue && prevValue.length < length) {
                prevValue.text = text;
                prevValue.length = length;
            }
            else if (!prevValue) {
                p[dataKey] = {
                    text: text,
                    length: length
                };
            }
        });
        return p;
    }, {});
    headers.forEach(function (x) {
        if (isMobile) {
            if (x !== 'name') {
                return;
            }
        }
        var dataKey = '__users-list__' + x.replace(/-/g, '');
        var text = (0, translation_1.getLocalization)("userfront/users-list/".concat(x)).toString();
        var length = (0, text_1.calculateStringLength)(text) + 42;
        var prevValue = columns[dataKey];
        if (prevValue && prevValue.length < length) {
            prevValue.text = text;
            prevValue.length = length;
        }
        else if (!prevValue) {
            columns[dataKey] = {
                text: text,
                length: length
            };
        }
    });
    return columns;
};
var setStyles = function (columns, setContentWidth, isMobile) {
    var contentWidth = 0;
    var lengths = Object.keys(columns).reduce(function (prev, x) {
        if (x === '__users-list__avatar') {
            return prev;
        }
        prev[x] = columns[x].length;
        return prev;
    }, {});
    // Override styles for dynamic classes
    var style = document.getElementById('UsersListCSS');
    if (style && style.parentNode) {
        style.parentNode.removeChild(style);
    }
    style = document.createElement('style');
    style.id = 'UsersListCSS';
    document.head && document.head.appendChild(style);
    var sheet = style.sheet;
    var staticIconCount = isMobile ? 0 : 1;
    contentWidth += 52 * Math.max(staticIconCount, 0); // append width of the static columns
    Object.keys(lengths).forEach(function (className, i) {
        var colwidth = Math.max(8, 4 + lengths[className] + 26); // convert to rem
        contentWidth += colwidth;
        sheet.insertRule(".".concat(className) +
            ' {max-width: ' +
            colwidth +
            'px;\n min-width: ' +
            colwidth +
            'px;}', i);
        setContentWidth(contentWidth);
    });
};
function getFilteredData(users, filters, searchString) {
    var keys = Object.keys(filters);
    var filtered = users;
    if (searchString.length > 0) {
        filtered = users.filter(function (user) {
            return user.name.toString().toLowerCase().includes(searchString.toLowerCase());
        });
    }
    if (keys.length > 0) {
        filtered = filtered.reduce(function (result, item) {
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var searchValue = filters[key];
                var value = item[key];
                if (key === 'name' &&
                    (value === '' ||
                        (value &&
                            value.toLowerCase().indexOf(searchValue.toLowerCase()) === -1))) {
                    return result;
                }
                if (value === '' ||
                    (value &&
                        value
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1)) {
                    return result;
                }
            }
            return __spreadArray(__spreadArray([], result, true), [item], false);
        }, []);
    }
    return filtered;
}
var sortByKeyValue = function (sortBy, order) {
    // set empty strings last in list
    return function (a, b) {
        if (a[sortBy] === '')
            return order;
        if (b[sortBy] === '')
            return order * -1;
        return a[sortBy].localeCompare(b[sortBy]) * order;
    };
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('showWarningModal', 'setShowWarningModal', {
    open: false,
    state: 'ENABLE'
}), (0, recompose_1.withState)('searchString', 'setSearchString', ''), (0, recompose_1.withState)('total', 'setTotal', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var _a = this.props, users = _a.users, filterOptions = _a.filterOptions, sortingAndPagination = _a.sortingAndPagination, isMobile = _a.isMobile, searchString = _a.searchString;
        var order = sortingAndPagination.order === 'asc' ? 1 : -1;
        var items = getFilteredData(users, filterOptions, searchString)
            .sort(sortByKeyValue(sortingAndPagination.sortBy, order))
            .slice(Math.max(0, Math.min(users.length, sortingAndPagination.offset)), Math.min(sortingAndPagination.offset + sortingAndPagination.limit, users.length));
        this.props.setItems(items);
        this.props.setTotal(items.length);
        this.props.setOffset(0);
        var columns = getColumns(items, isMobile);
        setStyles(columns, this.props.setContentWidth, isMobile);
    },
    componentDidUpdate: function (previousProps) {
        var _a = this.props, sortingAndPagination = _a.sortingAndPagination, filterOptions = _a.filterOptions, searchString = _a.searchString, users = _a.users, limit = _a.limit, offset = _a.offset, status = _a.status, isMobile = _a.isMobile, setTotal = _a.setTotal, setItems = _a.setItems, setOffset = _a.setOffset;
        if (sortingAndPagination !== previousProps.sortingAndPagination ||
            filterOptions !== previousProps.filterOptions ||
            isMobile !== previousProps.isMobile ||
            searchString !== previousProps.searchString ||
            offset !== previousProps.offset ||
            limit !== previousProps.limit ||
            users.length !== previousProps.users.length ||
            status !== previousProps.status) {
            var orderBy = sortingAndPagination.sortBy;
            var order = sortingAndPagination.order === 'asc' ? 1 : -1;
            var list = users;
            var data = getFilteredData(list, filterOptions, searchString).sort(sortByKeyValue(orderBy, order));
            var items = data.slice(Math.max(0, Math.min(data.length, sortingAndPagination.offset)), Math.min(sortingAndPagination.offset + sortingAndPagination.limit, data.length));
            setTotal(data.length);
            setItems(items);
            if (offset === previousProps.offset) {
                if (filterOptions !== previousProps.filterOptions ||
                    searchString !== previousProps.searchString) {
                    setOffset(0);
                }
            }
            if (previousProps.items !== items ||
                previousProps.isMobile !== isMobile ||
                this.props.contentWidth === 0) {
                var columns = getColumns(items, isMobile);
                setStyles(columns, this.props.setContentWidth, isMobile);
            }
        }
    }
}), recompose_1.pure);
function getHeaderColumn(props, name, identifier) {
    var order = props.sortingAndPagination.sortBy === identifier &&
        props.sortingAndPagination.order === 'asc'
        ? 'desc'
        : 'asc';
    var enabled = true;
    var dataKey = '__users-list__' + identifier;
    return (React.createElement("div", { "data-key": dataKey, "data-length": (0, translation_1.getLocalization)("userfront/users-list/".concat(name)).length, className: classNames('row__column users-list-list-row-column', dataKey) },
        React.createElement("div", { onClick: function () { return props.sortBy(identifier, order); } }, (0, translation_1.getLocalization)("userfront/users-list/".concat(name))),
        React.createElement(SortButton, { className: "d-none d-desktop-table-cell filter", order: props.sortingAndPagination.sortBy === identifier
                ? props.sortingAndPagination.order.toLowerCase()
                : null, disabled: !enabled, onChange: function () { return props.sortBy(identifier, order); } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: props.filterOptions && props.filterOptions[identifier]
                ? 'active'
                : '' + ' filter', columnIdentifier: identifier, textInputValue: props.filterOptions && props.filterOptions[identifier]
                ? props.filterOptions[identifier] || ''
                : '', inputType: 'text', setColumnFilterString: function (field, value) {
                props.setItems(props.items);
                props.setTotal(props.items.length);
                props.setOffset(0);
                props.setColumnFilter(field, value);
            }, clearColumnFilter: function (field) {
                props.setItems(props.items);
                props.setTotal(props.items.length);
                props.setOffset(0);
                props.setColumnFilter(field, undefined);
            } })));
}
var Header = function (props) {
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column first narrow avatar" }),
        getHeaderColumn(props, 'user', 'name'),
        !props.isMobile && getHeaderColumn(props, 'company', 'company'),
        !props.isMobile && getHeaderColumn(props, 'address', 'address'),
        !props.isMobile && getHeaderColumn(props, 'telephone', 'telephone'),
        !props.isMobile && getHeaderColumn(props, 'email', 'email'),
        !props.isMobile && getHeaderColumn(props, 'title', 'title')));
};
function getColumn(column, value, onClick) {
    return (React.createElement("div", { className: classNames("row__column __users-list__".concat(column), column === 'name' && 'expand'), "data-key": "__users-list__".concat(column), "data-length": value.length, onClick: onClick },
        React.createElement("span", null, value)));
}
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-users-list-lists', className: 'no-users-list-lists' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9') }),
    React.createElement("b", null, (0, translation_1.getLocalization)('userfront/users-list/no-users-notice')),
    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/users-list/no-users-notice-text')))); };
var createRowData = memoize(function (style, isMobile, items) { return ({
    style: style,
    isMobile: isMobile,
    items: items
}); });
var ListRow = React.memo(function (_a) {
    var _b;
    var index = _a.index, data = _a.data, style = _a.style;
    var isMobile = data.isMobile, items = data.items;
    var row = items[index];
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: classNames("row__column __users-list__avatar") },
            React.createElement("img", { className: classNames('icon'), src: (0, avatars_1.getAvatarUrl)(row.avatar) })),
        getColumn('name', "".concat(String(row.name))),
        !isMobile && getColumn('company', row.company),
        !isMobile && getColumn('address', row.address),
        !isMobile && getColumn('telephone', row.telephone),
        !isMobile && getColumn('email', row.email),
        !isMobile && getColumn('title', (_b = row.title) !== null && _b !== void 0 ? _b : '-')));
});
exports.PartiesListContainer = enhance(function (props) {
    var itemData = createRowData({}, props.isMobile, props.items);
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.Grid.Row, { className: "sok-search-bar-content" },
            React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12 },
                React.createElement("div", { className: "excel-button" },
                    React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { className: "fa-file-excel" }), color: "dark-gray", border: "green", onClick: function () { return props.getUserListExcel(props.projectId); } }, (0, translation_1.getLocalization)('userfront/users-list/export_excel'))),
                props.showToggleShowPartiesTab && (React.createElement("div", { className: classNames('toggle-checkbox') },
                    React.createElement(sok_ui_1.Input, { value: props.projectShowPartiesTab, disabled: props.projectId === -1, type: "checkbox", label: (0, translation_1.getLocalization)('userfront/users-list/toggle-show-parties'), onClick: function () {
                            return props.setShowWarningModal({
                                open: true,
                                state: props.projectShowPartiesTab === true
                                    ? 'DISABLE'
                                    : 'ENABLE'
                            });
                        } })))),
            React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12 },
                React.createElement(SearchBar_1.SearchBar, { placeHolder: (0, translation_1.getLocalization)('userfront/users-list/search-placeholder'), setSearchString: props.setSearchString }))),
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'users-list-view-list-container' },
                React.createElement("div", { className: 'sok-list-content users-list-view-list ' +
                        props.status.toLowerCase() },
                    props.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') })),
                    props.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                        React.createElement(sok_ui_1.LoadingSpinner, null))),
                    props.status === 'FETCHED' && (React.createElement(React.Fragment, null, itemData && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                        var width = _a.width, height = _a.height;
                        return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({}, props)), placeholder: React.createElement(NotFoundPlaceHolder, null) }, ListRow));
                    })))))),
            React.createElement(sok_ui_1.Pagination, { key: 'pagination', limit: props.limit, total: props.total, offset: props.offset, updatePageState: props.onPaginationChange })),
        React.createElement(PartiesTabConfirmModal_1.PartiesTabConfirmModal, { showWarningModal: props.showWarningModal, setShowWarningModal: props.setShowWarningModal, toggleShowParties: props.toggleShowParties, projectId: props.projectId, showPartiesTab: props.projectShowPartiesTab })));
});
